/**
 * Shared type guards for narrowing untyped API payloads.
 */
export function isRecord(x: unknown): x is Record<string, unknown> {
  return typeof x === "object" && x != null;
}
